import { Link } from 'react-router-dom';
import { sportCategories } from '@/mocks/home';

const categoryImages: Record<string, string> = {
  'home-football-cat': 'https://readdy.ai/api/search-image?query=Dramatic%20football%20soccer%20stadium%20night%20match%20atmosphere%20with%20bright%20stadium%20lights%20and%20green%20pitch%2C%20professional%20sports%20photography%2C%20dynamic%20action%20feel%2C%20clean%20dark%20background%20with%20warm%20lighting%20highlights%2C%20editorial%20quality&width=800&height=600&seq=home-football-cat&orientation=landscape',
  'home-basketball-cat': 'https://readdy.ai/api/search-image?query=Intense%20basketball%20court%20action%20with%20dramatic%20arena%20lighting%2C%20professional%20NBA%20style%20photography%2C%20warm%20court%20tones%2C%20dark%20background%20with%20spotlight%20effects%2C%20athletic%20energy%2C%20editorial%20quality&width=800&height=600&seq=home-basketball-cat&orientation=landscape',
  'home-tennis-cat': 'https://readdy.ai/api/search-image?query=Professional%20tennis%20court%20at%20sunset%20with%20dramatic%20sky%20colors%2C%20clean%20court%20lines%2C%20warm%20golden%20hour%20lighting%2C%20sports%20photography%20style%2C%20elegant%20atmosphere%2C%20editorial%20quality&width=800&height=600&seq=home-tennis-cat&orientation=landscape',
  'home-esports-cat': 'https://readdy.ai/api/search-image?query=Futuristic%20esports%20gaming%20arena%20with%20neon%20lights%20and%20dramatic%20atmosphere%2C%20professional%20gaming%20setup%2C%20dark%20background%20with%20colorful%20RGB%20accents%2C%20energetic%20competitive%20gaming%20vibe%2C%20editorial%20quality&width=800&height=600&seq=home-esports-cat&orientation=landscape',
  'home-comprehensive-cat': 'https://readdy.ai/api/search-image?query=Various%20sports%20equipment%20elegantly%20arranged%20in%20a%20modern%20dark%20studio%20setting%20with%20dramatic%20lighting%2C%20golf%20club%20and%20snooker%20balls%20and%20racing%20helmet%2C%20warm%20accent%20lighting%2C%20premium%20editorial%20photography&width=800&height=600&seq=home-comprehensive-cat&orientation=landscape',
};

export default function SportCategories() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto px-4 md:px-6 max-w-7xl">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门赛事分类
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            覆盖全球50+体育项目，实时赔率尽在掌握
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
          {sportCategories.map((category) => (
            <Link
              key={category.slug}
              to={`/category/${category.slug}`}
              className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={categoryImages[category.imageSeq]}
                  alt={category.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                  title={`${category.name} - 皇冠体育`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-4">
                  <div className="flex items-center gap-2 mb-1">
                    <div className="w-7 h-7 flex items-center justify-center rounded-lg bg-primary-500/90">
                      <i className={`${category.icon} text-background-50 text-xs`}></i>
                    </div>
                    <h3 className="font-heading text-base font-semibold text-background-50">
                      {category.name}
                    </h3>
                  </div>
                  <p className="text-foreground-300 text-xs mt-1">
                    {category.matchCount}场赛事进行中
                  </p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}